export default "__VITE_ASSET__Da0KF5cc__"